<template>
  <div>
    <div class="b-b p-v-10 bold fs-18" style="padding-left: 18px">
      添加成员
    </div>
    <div class="flex a-start">
      <div style="width: 45%;margin-left: 14px">
        <div class="flex flex-column">
          <div class="w-full" style="margin-top: 24px">
            <div class="redsuffixB" style="color: #333333; font-weight: 400">姓名：</div>
            <div class="b-b m-t-10">
              <Input class="FoundRenovation" placeholder="请输入姓名" style="width: 100%"
                     v-model="name"/>
            </div>
          </div>
          <div class="flex a-center j-start w-full" style="margin-top: 24px">
            <div class="w-70 d-inline-block" style="color: #333333; font-weight: 400">性别：</div>
            <RadioGroup v-model="gender">
              <Radio :label="1" class="">男</Radio>
              <Radio :label="2" class="m-l-10">女</Radio>
            </RadioGroup>
          </div>
          <div class="w-full" style="margin-top: 24px">
            <div class="redsuffixB" style="color: #333333; font-weight: 400">角色权限：</div>
            <div class="b-b m-t-10">
              <Select class="FoundRenovation" placeholder="请选择" v-model="rolePermission">
                <Option :key="item.value" :value="item.value" v-for="item in rolePermissionList">{{
                    item.label
                  }}
                </Option>
              </Select>
            </div>
          </div>
        </div>
      </div>
      <div class="p-t-20 p-l-80" style="width: 50%">
        <div class="redsuffixB m-b-20" style="color: #333333; font-weight: 400">头像：</div>

        <up-load-image @uploadSuccess="uploadImageSuccess" picurl="common/logo/">
          <div slot="tip">
            <div class="m-l-10">
              <div class="flex-column a-center j-center border"
                   style="width: 124px; height: 124px;background: #EDEDED;border-radius: 50%"
                   v-if="!icon">
                <img alt="" key="789" src="../../../assets/common/ic_upload_c.png"
                     style="width: 36px;height: 32px;">
                <span class="d-block m-t-5 fs-14" style="color:#999999">上传图片</span>
              </div>
              <div class="relative top-0 left-0" style="width: 124px; height: 124px;" v-if="icon">
                <img :src="icon" alt="" class="w-full h-full" key="123" style="border-radius: 50%">
                <img @click.stop="onImgDelClick" class="w-24 h-24 absolute right--12 top--12"
                     key="456"
                     src="../../../assets/common/ic_shanchu_red_sub.png">
              </div>
            </div>
          </div>
        </up-load-image>
      </div>
    </div>
    <div class="text-center m-t-60 m-b-35">
      <Button @click="onCancelClick" class="w-80" style="margin-right: 14px">取消</Button>
      <Button @click="onSubClick" class="w-80" type="primary">确定</Button>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import UpLoadImage from '../../../components/common/UpLoadImage'

export default {
  name: 'EditCustomerService',
  components: {UpLoadImage},
  props: {
    open: Boolean,
    uid: Number
  },
  data () {
    return {
      wechat: '',
      phone: '',
      name: '',
      icon: '',
      email: '',
      gender: 1,
      department: '',
      position: '',
      introduce: '',
      rolePermission: 4,
      isTrailer: 0,
      rolePermissionList: [
        //   {
        //   value: 1,
        //   label: '超级管理员'
        // }, {
        //   value: 2,
        //   label: '管理员'
        // }, {
        //   value: 3,
        //   label: '普通用户'
        // },
        {
          value: 4,
          label: '客服'
        }]

    }
  },
  watch: {
    open (newValue) {
      if (!newValue) {
        this.phone = ''
        this.email = ''
        this.name = ''
        this.icon = ''
        this.gender = 1
        this.department = ''
        this.position = ''
        this.introduce = ''
        this.wechat = ''
        this.isTrailer = 0
      }
    },
    uid: {
      handler (newValue) {
        if (parseInt(newValue) > 0) {
          this.getCustomerServiceUserInfo(parseInt(newValue)).then(res => {
            if (res.code === 0) {
              let data = res.data
              this.phone = data.linkPhone || ''
              this.name = data.name || ''
              this.icon = data.logo || ''
              this.gender = data.sex
              this.rolePermission = data.roleType || 4
              this.wechat = data.wechat || ''
              this.isTrailer = data.isTrailer || 0
            }
          })
        }
      },
      immediate: true
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    },
    onSubClick () {
      if (!this.name) {
        return this.$Message.info('请输入姓名')
      }
      if (!this.rolePermission) {
        return this.$Message.info('请选择角色')
      }
      let params = {
        name: this.name,
        logo: this.icon,
        sex: this.gender,
      }
      if (this.uid > 0) {
        let id = this.uid
        let p = {
          id: id,
          params: params
        }
        this.editCustomerServiceUserInfo(p).then(res => {
          if (res.code === 0) {
            this.$emit('subclick')
          }
          if (res.msg) {
            this.$Message.info(res.msg)
          }
        })
      }
    },
    uploadImageSuccess (data) {
      if (data && data.length) {
        this.icon = data[0].url
      }
    },
    onImgDelClick () {
      this.icon = ''
    },
    onCancelClick () {
      this.$emit('cancelclick')
    },

    /**
     * 下拉框选中客服
     */
    isCustomerService () {
      return this.rolePermission === 4
    },
    ...mapActions([
      'addAdminUser',
      'getAdminInfo',
      'editAdminInfo',
      'addCustomerServiceUser',
      'getCustomerServiceUserInfo',
      'editCustomerServiceUserInfo'
    ])
  }
}
</script>

<style lang="scss" scoped>
.FoundRenovation > .ivu-input {
  border: none;
  padding: 0;
}

.FoundRenovation > .ivu-select-selection {
  border: none;

}
</style>
